import React from "react";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import {motion} from 'framer-motion';
const MenuCard = ({ itemNum, handler, price, title, imgSrc, delay = 0}) => {
  return (
    <motion.div initial={{x:"-100%",opacity:0}} whileInView={{x:0,opacity:1}} transition={{delay,}}>
      <main className="menuCard">
        <figure>
          <img
            src={imgSrc}
            alt="product"
          />
        </figure>
        <h1>{title}</h1>
        <p>৳{price}/kg</p>
        <button onClick={()=>handler(itemNum)}>
            <RiMoneyDollarCircleLine /> <span>Buy now</span>
          </button>
      </main>
    </motion.div>
  );
};

export default MenuCard;
